import safeStringify from 'json-stringify-safe';
import {isNumber} from 'lodash';
import loglevel from 'loglevel'; // https://github.com/pimterry/loglevel/issues/149

import loglevelLocalStorage from './logLevelLocalStorage';

let logConfig = {};

export const doBuildLogger = (config, cb = null) => {
  const {browserLogLevel, level, maxStackSize, key, persistentLog} = config;
  logConfig = {browserLogLevel, level, maxStackSize, key};

  if (!isNumber(browserLogLevel) || !isNumber(level) || !maxStackSize || !key) {
    return;
  }
  // Must be called before setLevel.
  loglevelLocalStorage(
    loglevel,
    {
      level,
      prefix(logSev, ...args) {
        // Stringify for storage in localStorage.
        const newArgs = args.map((arg) =>
          typeof arg === 'object' && !(arg instanceof Date) ? safeStringify(arg) : arg,
        );

        return `[${new Date().toISOString()}] ${logSev}: ${newArgs.join(' ')}`;
      },
      callOriginal: true,
      maxLogStackSize: maxStackSize,
      storeKey: key,
      persistentLog,
    },
    cb,
  );

  loglevel.setLevel(browserLogLevel);

  console.trace = loglevel.trace;
  console.debug = loglevel.debug;
  console.log = loglevel.log;
  console.info = loglevel.info;
  console.warn = loglevel.warn;
  console.error = loglevel.error;
};

export const getLog = () => {
  const log = window.localStorage.getItem(logConfig.key);

  if (!log) {
    return [];
  }

  return JSON.parse(log);
};

export const clearLog = () => {
  window.localStorage.removeItem(logConfig.key);
};
